const templateUrl = require('./item-controls.html');

module.exports = angular.module('msi.products.removeactions', [
  require('./remove-actions')
]).name;

angular.module(module.exports)
  .component('ogItemControls', {
    bindings: {
      item: '<ogFor',
      onlyItemInShipment: '<?ogOnlyItemInShipment'
    },
    templateUrl: templateUrl
  });
